"use client"

import { signal } from './vidstack-CH225ns1.js';

const RemotionThumbnail = /* @__PURE__ */ signal(null);
const RemotionSliderThumbnail = /* @__PURE__ */ signal(null);
const RemotionPoster = /* @__PURE__ */ signal(null);

export { RemotionPoster, RemotionSliderThumbnail, RemotionThumbnail };
